import { Component } from '@angular/core';
import { LanguageService } from '@ibank-globals/language';

@Component({
	selector: 'loading-stage',
	template: require('./loading-stage.component.html')
})
export class LoadingStageComponent {
	private _resourcesFetching: boolean = false;

	public get loading(): boolean {
		return this._resourcesFetching;
	}

	constructor(private _langSvc: LanguageService) {
		this.initLoader();
	}

	protected initLoader() {
		this._langSvc.isFetching$.subscribe(loading => (this._resourcesFetching = loading));
	}
}
